/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "863c8fbfe98f496899ced1f989ea30db",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "863c8fbfe98f496899ced1f989ea30db",
            "region": "us-east-1"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://f2o2rluxwzhxhfl3o4ejah55au.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "us-east-1:6442b3ef-3aad-4bba-b859-7d9ec0b17043",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_pKSwHXnvl",
    "aws_user_pools_web_client_id": "67dfs8472jq06sivk3t4n1e49v",
    "oauth": {
        "domain": "almitra31254b53-31254b53-dbmain.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://dev.almitra.ai/,https://main.almitra.ai/,http://localhost:3000/",
        "redirectSignOut": "https://dev.almitra.ai/,https://main.almitra.ai/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dynamoAlmitra-dbmain",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
